import store from '../../../global-state/redux';

export const getJwtTokenBasedOnShort = (short) => {
  if (typeof short !== 'string') return undefined;
  const normalizedShort = short.trim().toUpperCase(); // response from Chen have shorts in uppercase, so we normalize the input to match that format
  if (!normalizedShort) return undefined;

  const jwtTokensForMultipleEvents = store.getState()?.appState?.jwtTokensForMultipleEvents ?? {};
  if (!jwtTokensForMultipleEvents || typeof jwtTokensForMultipleEvents !== 'object') return undefined;

  return jwtTokensForMultipleEvents[normalizedShort];
};
